import React from 'react'
import './Controls.css'
import leftArrow from '../../images/leftArrow.png'
import rightArrow from '../../images/rightArrow.png'

const Controls = () => {
  return (
    <>
        <div className='leftBtn ctnBTn'>
        <img src={leftArrow} alt="leftArrow" className='cntImages' /> <span>WOMENS</span>
        </div>
        
        <div className='rigthBtn ctnBTn'>
         <span>KIDS</span> <img src={rightArrow} alt="rightArrow" className='cntImages' />
        </div>

        <div className='page-controls'>
            <span className='active'></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    </>
  )
}

export default Controls